// frontend/src/services/users.ts
import api from "@/utils/axios";
import type { Language } from "@/locales/locales";

export type UserProfile = {
  id: number;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  language?: Language | null;
  country?: string | null;
  currency?: string | null;
  is_verified: boolean;
};

type UpdatableUserFields = Partial<
  Pick<UserProfile, "first_name" | "last_name" | "language" | "country" | "currency">
>;

export async function getMe(): Promise<UserProfile> {
  const { data } = await api.get("/api/users/me");
  return data as UserProfile;
}

export async function updateMe(payload: UpdatableUserFields): Promise<UserProfile> {
  const { data } = await api.patch("/api/users/me", payload);
  return data as UserProfile;
}

/**
 * Convenience helper when changing only language.
 * Keeps callsites tidy in Settings.
 */
export async function updateLanguage(language: Language): Promise<UserProfile> {
  return updateMe({ language });
}